module.exports = __webpack_public_path__ + "static/img/1.2da7ca08.jpg";